import images from 'assets/images';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import type { ICommonProps } from '../types/propTypes';

const MainLayout = (props: ICommonProps) => {
    const { children, t } = props;
    return (
        <div className="wrapper">
            <header className="header">
                <div className="container-xl">
                    <div className="row no-gutters align-items-center">
                        <div className="col">
                            <Navbar expand="lg">
                                <Navbar.Brand as={Link} to="/" title={t('navbar.title')}>
                                    <img src={images.logo} alt={t('navbar.title')} />
                                </Navbar.Brand>
                            </Navbar>
                        </div>
                    </div>
                </div>
            </header>
            <main className="main-content">
                <div className="container-xl">
                    <div className="card mb-4">{children}</div>
                </div>
            </main>
        </div>
    );
};

export default MainLayout;
